import { logger } from "@formant/core/common/logger";

export function forceGarbageCollection() {
    // https://stackoverflow.com/a/66546935
    logger.debug("forceGarbageCollection() triggered");
    queueMicrotask(() => {
        let img: HTMLImageElement | null = document.createElement("img");
        img.src = window.URL.createObjectURL(new Blob([new ArrayBuffer(5e7)])); // 50Mb or less or more depending as you wish to force/invoke GC cycle run
        img.onerror = function () {
            window.URL.revokeObjectURL(this.src);
            img = null;
        };
    });
}
